document.documentElement.classList.remove('no-js');

const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
  style: 'currency',
  currency: window.Shopify?.currency?.active || 'INR'
});

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  button.addEventListener('click', () => document.body.classList.toggle('menu-open'));
});

const angularHeader = document.querySelector('[data-angular-header]');
if (angularHeader) {
  const updateHeaderCollapse = () => {
    angularHeader.classList.toggle('collapsed', window.scrollY > 100);
    document.body.classList.toggle('announcement-hidden', window.scrollY > 20);
  };
  updateHeaderCollapse();
  window.addEventListener('scroll', updateHeaderCollapse, { passive: true });
}

const dropdownPanel = document.querySelector('[data-dropdown-panel]');
if (dropdownPanel) {
  const dropdownContents = [...dropdownPanel.querySelectorAll('[data-dropdown-content]')];
  const showDropdown = (name) => {
    dropdownPanel.classList.add('is-active');
    dropdownContents.forEach((item) => item.classList.toggle('is-active', item.dataset.dropdownContent === name));
  };
  document.querySelectorAll('[data-dropdown-trigger]').forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => showDropdown(trigger.dataset.dropdownTrigger));
    trigger.addEventListener('focus', () => showDropdown(trigger.dataset.dropdownTrigger));
  });
  dropdownPanel.addEventListener('mouseleave', () => dropdownPanel.classList.remove('is-active'));
}

document.querySelectorAll('[data-search-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    dropdownPanel?.classList.remove('is-active');
    document.body.classList.toggle('search-open');
    if (document.body.classList.contains('search-open')) {
      setTimeout(() => document.querySelector('[data-search-panel] input')?.focus(), 100);
    }
  });
});

(() => {
  const searchForms = [...document.querySelectorAll('[data-ajax-search-form]')];
  if (!searchForms.length) return;

  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[char]);

  const searchCache = new Map();
  let searchController;
  let searchTimer;

  const setAllResults = (html) => {
    document.querySelectorAll('[data-ajax-search-results]').forEach((node) => {
      node.innerHTML = html;
    });
  };

  const productPrice = (product) => {
    if (product.price) return product.price;
    if (product.compare_at_price_min) return product.compare_at_price_min;
    return '';
  };

  const renderSearchResults = (products, query) => {
    if (!products.length) {
      setAllResults('<p class="searchMessage">No products found</p>');
      return;
    }

    const items = products.map((product) => {
      const title = escapeHtml(product.title || product.name || 'Product');
      const url = product.url || `/search?q=${encodeURIComponent(query)}&type=product`;
      const image = product.image || product.featured_image?.url || product.featured_image || '';
      const collection = escapeHtml(product.product_type || product.vendor || '');
      const price = escapeHtml(productPrice(product));
      return `
        <a class="searchResultItem" href="${url}">
          ${image ? `<img src="${image}" alt="${title}" loading="lazy">` : '<span class="searchResultImagePlaceholder"></span>'}
          <span class="searchResultMeta">
            ${collection ? `<span class="searchResultCollection">${collection}</span>` : ''}
            <span class="searchResultName">${title}</span>
            ${price ? `<span class="searchResultPrice">${price}</span>` : ''}
          </span>
        </a>
      `;
    }).join('');

    setAllResults(`
      <div class="searchResultGrid">${items}</div>
      <a class="searchViewAll" href="/search?q=${encodeURIComponent(query)}&type=product">View all results</a>
    `);
  };

  const runSearch = async (query) => {
    const term = query.trim();
    if (term.length < 2) {
      setAllResults('<p class="searchMessage">Start typing to search products</p>');
      return;
    }

    if (searchCache.has(term)) {
      renderSearchResults(searchCache.get(term), term);
      return;
    }

    searchController?.abort();
    searchController = new AbortController();
    setAllResults('<p class="searchMessage">Searching...</p>');

    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
        signal: searchController.signal
      });
      if (!response.ok) throw new Error('Search request failed');
      const payload = await response.json();
      const products = payload.resources?.results?.products || [];
      searchCache.set(term, products);
      renderSearchResults(products, term);
    } catch (error) {
      if (error.name === 'AbortError') return;
      setAllResults('<p class="searchMessage">Search is unavailable. Press enter to view results.</p>');
    }
  };

  searchForms.forEach((form) => {
    const input = form.querySelector('[data-ajax-search-input]');
    if (!input) return;

    input.addEventListener('input', () => {
      document.querySelectorAll('[data-ajax-search-input]').forEach((field) => {
        if (field !== input) field.value = input.value;
      });
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => runSearch(input.value), 250);
    });

    form.addEventListener('submit', (event) => {
      const term = input.value.trim();
      if (term.length < 2) {
        event.preventDefault();
        setAllResults('<p class="searchMessage">Type at least 2 characters to search</p>');
      }
    });
  });
})();

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.body.classList.remove('search-open', 'menu-open');
    dropdownPanel?.classList.remove('is-active');
  }
});

document.querySelectorAll('.productCard .imageFade').forEach((image) => {
  const reveal = () => image.classList.add('is-loaded');
  if (image.complete && image.naturalWidth > 0) {
    reveal();
  } else {
    image.addEventListener('load', reveal, { once: true });
  }
});

(() => {
  const modal = document.querySelector('[data-size-chart-modal]');
  const modalImage = modal?.querySelector('[data-size-chart-image]');
  if (!modal || !modalImage) return;

  const openModal = (src) => {
    modalImage.src = src;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('size-chart-open');
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('size-chart-open');
    modalImage.removeAttribute('src');
  };

  document.querySelectorAll('[data-size-chart-open]').forEach((button) => {
    button.addEventListener('click', () => openModal(button.dataset.sizeChartSrc));
  });

  document.querySelectorAll('[data-size-chart-close]').forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();

document.querySelectorAll('[data-slider]').forEach((slider) => {
  const slides = [...slider.querySelectorAll('.hero-slide')];
  const dots = [...slider.querySelectorAll('[data-slide-dot]')];
  if (slides.length < 2) return;
  let active = 0;
  const show = (index) => {
    slides[active].classList.remove('is-active');
    dots[active]?.classList.remove('is-active');
    active = index;
    slides[active].classList.add('is-active');
    dots[active]?.classList.add('is-active');
  };
  dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
  setInterval(() => show((active + 1) % slides.length), Number(slider.dataset.autoplay) || 6000);
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const thumbnails = [...root.querySelectorAll('[data-thumbnail]')];
  const media = [...root.querySelectorAll('[data-media]')];
  const lightbox = document.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-product-lightbox-image]');
  const lightboxImages = [...root.querySelectorAll('[data-product-lightbox-open]')].map((button) => ({
    src: button.dataset.fullImage,
    alt: button.querySelector('img')?.alt || ''
  }));
  let activeLightboxIndex = 0;

  const showLightboxImage = (index) => {
    if (!lightboxImage || !lightboxImages.length) return;
    activeLightboxIndex = (index + lightboxImages.length) % lightboxImages.length;
    const image = lightboxImages[activeLightboxIndex];
    lightboxImage.src = image.src;
    lightboxImage.alt = image.alt;
  };

  const openLightbox = (index) => {
    if (!lightbox || !lightboxImage || !lightboxImages.length) return;
    showLightboxImage(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
  };

  const closeLightbox = () => {
    if (!lightbox || !lightboxImage) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('lightbox-open');
    lightboxImage.removeAttribute('src');
  };

  thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
    const index = Number(thumbnail.dataset.thumbnail);
    thumbnails.forEach((item) => item.classList.remove('is-active'));
    media.forEach((item) => item.classList.remove('is-active'));
    thumbnail.classList.add('is-active');
    media[index]?.classList.add('is-active');
  }));

  root.querySelectorAll('[data-product-lightbox-open]').forEach((button) => {
    button.addEventListener('click', () => openLightbox(Number(button.dataset.lightboxIndex || 0)));
  });

  lightbox?.querySelector('[data-product-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.querySelector('[data-product-lightbox-prev]')?.addEventListener('click', () => showLightboxImage(activeLightboxIndex - 1));
  lightbox?.querySelector('[data-product-lightbox-next]')?.addEventListener('click', () => showLightboxImage(activeLightboxIndex + 1));
  lightbox?.addEventListener('click', (event) => {
    if (event.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (event) => {
    if (!lightbox?.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showLightboxImage(activeLightboxIndex - 1);
    if (event.key === 'ArrowRight') showLightboxImage(activeLightboxIndex + 1);
  });

  const form = root.querySelector('[data-product-form]');
  const variantSelect = root.querySelector('[data-variant-select]');
  const optionInputs = [...root.querySelectorAll('.variant-option input')];
  const addButton = root.querySelector('[data-add-to-cart]');
  const price = root.querySelector('[data-product-price]');
  if (!form || !variantSelect) return;

  const updateVariant = () => {
    const selectedOptions = [...new Set(optionInputs.map((input) => input.name))]
      .map((name) => form.querySelector(`input[name="${name}"]:checked`)?.value);
    const option = [...variantSelect.options].find((item) => {
      try { return JSON.parse(item.dataset.options).every((value, index) => value === selectedOptions[index]); }
      catch { return false; }
    });
    if (!option) return;
    variantSelect.value = option.value;
    const available = option.dataset.available === 'true';
    addButton.disabled = !available;
    addButton.textContent = available ? 'Add to cart' : 'Sold out';
    price.textContent = option.dataset.price || money.format(0);
    history.replaceState({}, '', `${location.pathname}?variant=${option.value}`);
  };
  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
});

(() => {
  const CART_KEY = 'cartItemsV3';
  const cartArea = document.querySelector('[data-cart-area]');
  if (!cartArea) return;

  const drawer = cartArea.querySelector('[data-cart-drawer]');
  const itemsContainer = cartArea.querySelector('[data-cart-items]');
  const filledState = cartArea.querySelector('[data-cart-filled]');
  const emptyState = cartArea.querySelector('[data-cart-empty]');
  const subtotalNode = cartArea.querySelector('[data-cart-subtotal]');
  const taxNode = cartArea.querySelector('[data-cart-tax]');
  const totalNode = cartArea.querySelector('[data-cart-total]');
  const loader = cartArea.querySelector('[data-cart-loader]');
  let cartItems = [];
  let syncTimer;

  const formatMoney = (cents) => money.format((Number(cents) || 0) / 100);
  const itemPriceCents = (item) => Number(item.priceCents ?? Math.round(Number(item.data?.display_price || 0) * 100));
  const itemQuantity = (item) => Number(item.quantity || 0);
  const subtotalCents = () => cartItems.reduce((total, item) => total + itemPriceCents(item) * itemQuantity(item), 0);

  const normalizeLocalItem = (item) => ({
    data: {
      id: Number(item.data?.id ?? item.id),
      handle: item.data?.handle || item.handle || '',
      name: item.data?.name || item.name || item.data?.title || 'Product',
      variant_name: item.data?.variant_name || item.variantTitle || item.variant_title || '',
      display_price: Number(item.data?.display_price ?? ((item.priceCents || item.price || 0) / 100)),
      collection: item.data?.collection || item.collection || ''
    },
    quantity: Number(item.quantity || 1),
    thumbnail: item.thumbnail || item.image || '',
    url: item.url || item.data?.url || (item.data?.handle ? `/products/${item.data.handle}` : '/cart'),
    priceCents: Number(item.priceCents ?? item.price ?? Math.round(Number(item.data?.display_price || 0) * 100))
  });

  const normalizeShopifyCart = (cart) => (cart.items || []).map((item) => {
    const existingItem = cartItems.find((entry) => Number(entry.data?.id) === Number(item.variant_id));
    return normalizeLocalItem({
      data: {
        id: item.variant_id,
        handle: item.handle,
        name: item.product_title,
        variant_name: item.variant_title === 'Default Title' ? '' : item.variant_title,
        display_price: item.final_price / 100,
        collection: existingItem?.data?.collection || item.product_type || item.vendor || ''
      },
      quantity: item.quantity,
      thumbnail: item.image,
      url: item.url,
      priceCents: item.final_price
    });
  });

  const loadLocalCart = () => {
    try {
      cartItems = JSON.parse(localStorage.getItem(CART_KEY) || '[]').map(normalizeLocalItem);
    } catch {
      cartItems = [];
    }
  };

  const saveLocalCart = () => {
    localStorage.setItem(CART_KEY, JSON.stringify(cartItems));
  };

  const updateCartCounts = () => {
    const count = cartItems.reduce((total, item) => total + itemQuantity(item), 0);
    document.querySelectorAll('.cart-count').forEach((node) => {
      node.textContent = String(count);
    });
  };

  const renderCart = () => {
    updateCartCounts();
    const hasItems = cartItems.length > 0;
    filledState.hidden = !hasItems;
    emptyState.hidden = hasItems;

    if (itemsContainer) {
      itemsContainer.innerHTML = cartItems.map((item) => {
        const title = item.data.name || 'Product';
        const variantTitle = item.data.variant_name || '';
        const collection = item.data.collection || '';
        const image = item.thumbnail || '';
        const url = item.url || '/cart';
        const linePrice = formatMoney(itemPriceCents(item) * itemQuantity(item));
        return `
          <div class="cartItem" data-cart-line="${item.data.id}">
            <a href="${url}" data-cart-product-link data-cart-close>
              ${image ? `<img src="${image}" alt="${title.replace(/"/g, '&quot;')}" loading="lazy">` : ''}
            </a>
            <a href="${url}" class="cartItem__meta" data-cart-close>
              ${collection ? `<h6 class="cartItem__collection">${collection}</h6>` : ''}
              <h4>${title}</h4>
              ${variantTitle ? `<h6 class="cartItem__variant">${variantTitle}</h6>` : ''}
              <h5 class="price">${linePrice} ${item.quantity ? ` ( Nos. ${item.quantity} )` : ''}</h5>
            </a>
            <div class="quantityButtons">
              <button type="button" data-cart-increase="${item.data.id}" aria-label="Increase ${title}">+</button>
              <button type="button" data-cart-decrease="${item.data.id}" aria-label="Decrease ${title}">-</button>
            </div>
          </div>
        `;
      }).join('');
    }

    const subtotal = subtotalCents();
    const tax = Math.round(subtotal * 0.05);
    subtotalNode.textContent = formatMoney(subtotal);
    taxNode.textContent = formatMoney(tax);
    totalNode.textContent = formatMoney(subtotal);
  };

  const openCart = () => {
    cartArea.classList.add('show');
    document.body.classList.add('cart-open');
    document.body.classList.remove('menu-open');
    drawer?.setAttribute('aria-hidden', 'false');
  };

  const closeCart = () => {
    cartArea.classList.remove('show');
    document.body.classList.remove('cart-open');
    drawer?.setAttribute('aria-hidden', 'true');
  };

  const fetchShopifyCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to read Shopify cart');
    return response.json();
  };

  const syncToShopify = async ({ showLoader = false } = {}) => {
    clearTimeout(syncTimer);
    const updates = {};
    cartItems.forEach((item) => {
      updates[item.data.id] = itemQuantity(item);
    });

    if (showLoader) loader?.classList.add('show');
    try {
      const currentShopifyCart = await fetchShopifyCart();
      (currentShopifyCart.items || []).forEach((item) => {
        if (updates[item.variant_id] === undefined) updates[item.variant_id] = 0;
      });
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!response.ok) throw new Error('Unable to sync Shopify cart');
      const shopifyCart = await response.json();
      cartItems = normalizeShopifyCart(shopifyCart);
      saveLocalCart();
      renderCart();
    } catch (error) {
      console.warn(error);
    } finally {
      loader?.classList.remove('show');
    }
  };

  const queueSync = () => {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(() => syncToShopify(), 250);
  };

  const changeQuantity = (variantId, delta) => {
    const id = Number(variantId);
    const item = cartItems.find((entry) => Number(entry.data.id) === id);
    if (!item) return;
    item.quantity = itemQuantity(item) + delta;
    cartItems = cartItems.filter((entry) => itemQuantity(entry) > 0);
    saveLocalCart();
    renderCart();
    queueSync();
  };

  const addLocalItem = (item) => {
    const normalized = normalizeLocalItem(item);
    const existing = cartItems.find((entry) => Number(entry.data.id) === Number(normalized.data.id));
    if (existing) {
      existing.quantity += normalized.quantity;
    } else {
      cartItems.push(normalized);
    }
    saveLocalCart();
    renderCart();
    openCart();
    queueSync();
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openCart();
    });
  });

  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('[data-cart-product-link]');
    if (productLink) {
      const productUrl = new URL(productLink.href, window.location.origin);
      if (productUrl.pathname === window.location.pathname) {
        event.preventDefault();
        closeCart();
        return;
      }
    }

    const close = event.target.closest('[data-cart-close]');
    if (close) closeCart();

    const increase = event.target.closest('[data-cart-increase]');
    if (increase) {
      event.preventDefault();
      changeQuantity(increase.dataset.cartIncrease, 1);
    }

    const decrease = event.target.closest('[data-cart-decrease]');
    if (decrease) {
      event.preventDefault();
      changeQuantity(decrease.dataset.cartDecrease, -1);
    }
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const variantId = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity') || 1);
      const productMeta = form.querySelector('[data-product-meta]');
      const variantSelect = form.querySelector('[data-variant-select]');
      const selectedOption = variantSelect?.selectedOptions?.[0];
      const productUrl = productMeta?.dataset.productUrl || location.pathname;
      const handle = productUrl.split('/products/')[1]?.split('?')[0] || '';
      addLocalItem({
        data: {
          id: variantId,
          handle,
          name: productMeta?.dataset.productTitle,
          variant_name: selectedOption?.dataset.variantTitle === 'Default Title' ? '' : selectedOption?.dataset.variantTitle,
          display_price: Number(selectedOption?.dataset.priceCents || 0) / 100,
          collection: productMeta?.dataset.productCollection
        },
        quantity,
        thumbnail: productMeta?.dataset.productImage,
        url: productUrl,
        priceCents: Number(selectedOption?.dataset.priceCents || 0)
      });
    });
  });

  cartArea.querySelector('[data-cart-checkout]')?.addEventListener('click', async () => {
    await syncToShopify({ showLoader: true });
    window.location.href = '/checkout';
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });

  loadLocalCart();
  renderCart();
  fetchShopifyCart()
    .then((shopifyCart) => {
      if (shopifyCart.item_count > 0) {
        cartItems = normalizeShopifyCart(shopifyCart);
        saveLocalCart();
        renderCart();
      } else if (cartItems.length > 0) {
        syncToShopify();
      }
    })
    .catch(() => {});
})();
